import React, { useState } from "react";
import { Select, Input, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./multi-select.scss";

type Option = {
  label: string;
  value: string;
};

type MultiSelectWithSearchProps = {
  options?: Option[];
  value?: string[];
  onChange?: (val: string[]) => void;
  placeholder?: string;
  width?: number | string;
  maxTagCount?: number | "responsive";
  className?: string;
};

const MultiSelectWithSearch: React.FC<MultiSelectWithSearchProps> = ({
  options, // ✅ default options
  value,
  onChange,
  placeholder,
  maxTagCount = "responsive",
  className,
}) => {
  const [search, setSearch] = useState("");

  const selected = value || [];

  const filteredOptions = options?.filter(opt =>
    opt.label.toLowerCase().includes(search.toLowerCase())
  );

  const handleChange = (val: any[]) => {
    // Extract just the values from labelInValue format
    const values = val.map(item => typeof item === 'string' ? item : item.value);
    onChange?.(values);
  };

  return (
    <Select
      className={`${className} multi-select-search`}
      rootClassName="root-multi-select-search"
      mode="multiple"
      value={value}
      maxTagCount={maxTagCount}
      options={options}
      labelInValue
      onChange={handleChange}
      showSearch={false} // ✅ disable default input search
      placeholder={placeholder}
      dropdownRender={() => (
        <div>
          {/* ✅ Custom search bar inside dropdown */}
          <div>
            <Input
              className="search-multi-select"
              placeholder="Search"
              prefix={<SearchOutlined className="search-icon" />}
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          {/* ✅ Custom options list with checkboxes */}
          <div style={{ maxHeight: 200, overflowY: "auto", padding: "0 8px" }}>
            {filteredOptions?.map((opt) => (
              <div
                key={opt.value}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "4px 0",
                  cursor: "pointer",
                  fontSize: "1.5rem"
                }}
                onClick={() => {
                  if (selected.includes(opt.value)) {
                    handleChange(selected.filter(v => v !== opt.value));
                  } else {
                    handleChange([...selected, opt.value]);
                  }
                }}
              >
                <Checkbox
                  checked={selected.includes(opt.value)}
                  style={{ marginRight: 8 }}
                />
                {opt.label}
              </div>
            ))}
          </div>
        </div>
      )}
    />
  );
};

export default MultiSelectWithSearch;
